import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import MuiButton from '@mui/material/Button';
import { TextInput } from '../../../../../ui/input/text_input/text_input';
import { UserRole } from '../../../../../utils/types/admin_types';
import { SelectPermissions } from './select_permissions';

type EditRoleModalProps = {
  role: UserRole;
  entities: string[];
  editRole: (role: UserRole, roleName: string, permissions: string[]) => void;
};

const actions: string[] = ['create', 'edit', 'delete', 'view'];

function EditRoleModal({
  role,
  entities,
  editRole,
}: EditRoleModalProps): JSX.Element {
  const [selectedActions, setSelectedActions] = useState<string[]>(
    role.permissions,
  );
  const [roleName, setRoleName] = useState<string>(role.roleName);

  return (
    <Stack spacing={2.5} sx={{ width: '100%', pt: 1 }}>
      <Box sx={{ width: { xs: '100%', sm: '80%' } }}>
        <TextInput
          name='roleName'
          value={roleName}
          type='text'
          label='Role Name'
          onChange={(event) => setRoleName(event.target.value)}
        />
      </Box>
      <SelectPermissions
        selectedActions={selectedActions}
        setSelectedActions={setSelectedActions}
        entities={entities}
        actions={actions}
      />
      <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
        <MuiButton
          onClick={() => editRole(role, roleName, selectedActions)}
          variant='contained'
          sx={{
            borderRadius: '6px',
            textTransform: 'none',
            fontWeight: 600,
            bgcolor: '#093725',
            '&:hover': { bgcolor: '#062619' },
          }}
        >
          Edit Role
        </MuiButton>
      </Box>
    </Stack>
  );
}

export default EditRoleModal;
